export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e: any) {
    return false;
  }
  return true;
};
